import React from 'react';
import {ColorValue, StyleProp, TextInput, TextInputProps, TextStyle} from 'react-native';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import Div from '../lib/Div';
import P from '../lib/P';

type LabelProps = Omit<React.ComponentProps<typeof P>, 'children'>;

export type CardEntryFieldsTheme = {
  labelProps: LabelProps, inputStyle: StyleProp<TextStyle>, inputWithIconTextStyle: StyleProp<TextStyle>,
  inputIconStyle: StyleProp<TextStyle>, placeholderTextColor: ColorValue, iconColor: ColorValue
};

type Props = {
  accountHolderName: string, cardNumberInputProps: TextInputProps, expiryInputProps: TextInputProps,
  cvcInputProps: TextInputProps, disabled: boolean, theme: CardEntryFieldsTheme
};

const CardEntryFields = (props: Props) => {
  const {accountHolderName, cardNumberInputProps, expiryInputProps, cvcInputProps, disabled, theme} = props;

  return (
    <>
      <Div>
        <P {...theme.labelProps}>Account Holder Name</P>
        <TextInput
          value={accountHolderName} autoCapitalize="words" autoCorrect={false} style={theme.inputStyle}
          editable={false} accessibilityLabel="Account holder name from profile" textContentType="name"
          autoComplete="name"
        />
      </Div>

      <Div>
        <P {...theme.labelProps}>Card Number</P>
        <Div position="relative">
          <MaterialIcons name="credit-card" size={20} color={theme.iconColor} style={theme.inputIconStyle}/>
          <TextInput
            {...cardNumberInputProps} style={[theme.inputStyle, theme.inputWithIconTextStyle]} autoComplete="cc-number"
            placeholder="0000 0000 0000 0000" placeholderTextColor={theme.placeholderTextColor}
            keyboardType="number-pad" autoCorrect={false} editable={!disabled} accessibilityLabel="Card number"
            textContentType="creditCardNumber"
          />
        </Div>
      </Div>

      <Div row gap={12}>
        <Div flex={1}>
          <P {...theme.labelProps}>Expiry Date</P>
          <TextInput
            {...expiryInputProps} style={theme.inputStyle} placeholder="MM/YY" keyboardType="number-pad"
            placeholderTextColor={theme.placeholderTextColor} autoCorrect={false} autoComplete="cc-exp"
            editable={!disabled} accessibilityLabel="Expiry date"
          />
        </Div>

        <Div flex={1}>
          <P {...theme.labelProps}>CVC</P>
          <TextInput
            {...cvcInputProps} style={theme.inputStyle} placeholder="123" keyboardType="number-pad" autoCorrect={false}
            placeholderTextColor={theme.placeholderTextColor} autoComplete="cc-csc" secureTextEntry editable={!disabled}
            accessibilityLabel="CVC"
          />
        </Div>
      </Div>
    </>
  );
}

export default React.memo(CardEntryFields);
